<template>
	<div id="chartjs">
		<h5>Area Chart</h5>
		<area-chart :data="chartData1" :colors="['#b00', '#666', '#ff0', '#f0f', '#0ff']" prefix="$" suffix="%"></area-chart>
		<hr>
		<h5>Line Chart</h5>
		<line-chart :data="chartData1" :discrete="true" label="Value"  xtitle="Time" ytitle="Population" :curve="false" :legend="true"  legend="bottom"></line-chart>
		<hr>
		<h5>Pie Chart</h5>
		<pie-chart :data="[['Blueberry', 44], ['Strawberry', 23],  ['Otherberry', 33]]"></pie-chart>
		<hr>
		<h5>Pie Chart Donut</h5>
		<pie-chart :donut="true" :data="[['Blueberry', 44], ['Strawberry', 23],  ['Otherberry', 33]]"></pie-chart>
		<hr>
		<h5>Column Chart</h5>
		<column-chart :data="[['Sun', 32], ['Mon', 46], ['Tue', 28]]" :stacked="true"></column-chart>
		<hr>
		<h5>Bar Chart</h5>
		<bar-chart :data="[['Work', 32], ['Play', 1492]]"></bar-chart>
		<hr>
		<h5>Scatter Chart</h5>
		<scatter-chart :data="[[174.0, 80.0], [176.5, 82.3], [178.3, 60.3]]" xtitle="Size" ytitle="Population"></scatter-chart>
		<hr>
		<h5>Geo chart - Google Charts</h5>
		<geo-chart :data="[['United States', 44], ['Germany', 23], ['Brazil', 22]]"></geo-chart>
		<hr>
		<h5>Timeline - Google Charts</h5>
		<timeline :data="[['Washington', '1789-04-29', '1797-03-03'], ['Adams', '1797-03-03', '1801-03-03']]"></timeline>
		<br>
		<a href="https://github.com/ankane/vue-chartkick" target="_blank" class="btn btn-info">Más configuraciones</a>
	</div>
</template>

<script>
import { mapState, mapMutations } from 'vuex';

export default {
	name: 'Chartjs',
	data() {
		return {
			chartData1: [{"name":"Workout","data":{"2013-02-10":3,"2013-02-17":3,"2013-02-24":3,"2013-03-03":1,"2013-03-10":4,"2013-03-17":3,"2013-03-24":2,"2013-03-31":3}},{"name":"Go to concert","data":{"2013-02-10":0,"2013-02-17":0,"2013-02-24":0,"2013-03-03":0,"2013-03-10":2,"2013-03-17":1,"2013-03-24":0,"2013-03-31":0}},{"name":"Wash face","data":{"2013-02-10":0,"2013-02-17":1,"2013-02-24":0,"2013-03-03":0,"2013-03-10":0,"2013-03-17":1,"2013-03-24":0,"2013-03-31":1}},{"name":"Call parents","data":{"2013-02-10":5,"2013-02-17":3,"2013-02-24":2,"2013-03-03":0,"2013-03-10":0,"2013-03-17":1,"2013-03-24":1,"2013-03-31":0}},{"name":"Eat breakfast","data":{"2013-02-10":3,"2013-02-17":2,"2013-02-24":1,"2013-03-03":0,"2013-03-10":2,"2013-03-17":2,"2013-03-24":3,"2013-03-31":0}}],
			chartData2: [
        ['Year', 'Sales', 'Expenses', 'Profit'],
        ['2014', 1000, 400, 200],
        ['2015', 1170, 460, 250],
        ['2016', 660, 1120, 300],
        ['2017', 1030, 540, 350]
      ],
      chartOptions2: {
        chart: {
          title: 'Company Performance',
          subtitle: 'Sales, Expenses, and Profit: 2014-2017',
        }
      }
		}
	},
	methods: {
		...mapMutations(['changeTitleModule', 'changeSubTitleModule']),
		initModule() {
			this.changeTitleModule('Modulo de Chartjs')
			this.changeSubTitleModule('')
		},
	},
	components: {
	},
	mounted () {
		this.initModule()
	}
}

</script>

<style>
</style>